// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewItem-Skeleton_cls1__chhOC","cls2":"PaymentViewItem-Skeleton_cls2__sCpQs PaymentViewItem-Skeleton_cls1__chhOC"};